import React, { useEffect, useRef, useState } from "react";

import "./Product_filter.css";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import Slider from "@mui/material/Slider";
import {
  Brandings,
  getAllCategories,
  getAllColor,
  getAllFrameType,
  getAllGender,
  getAllMaterial,
  getAllShape,
} from "../../../features/master/masterSlice";
import { useDispatch, useSelector } from "react-redux";

const FILTER_ICON = "/assets/images/all-products/filter/Spectacles.png";

const Product_filter = ({
  handleFilterReset,
  onFilterChange,
  setPrice,
  filters,
}) => {
  const dispatch = useDispatch();

  const priceRange = useSelector((state) => state.master.price_range);

  const containerRef = useRef(null);

  // AUTO SCROLL UP WHEN ACCORDION OPENS
  const handleAccordionOpen = (e) => {
    setTimeout(() => {
      const item = e.target.closest(".accordion-item");
      if (item && containerRef.current) {
        containerRef.current.scrollTo({
          top: item.offsetTop - 20,
          behavior: "smooth",
        });
      }
    }, 200);
  };

  const lowest = Number(priceRange?.lowest_price) || 0;
  const highest = Number(priceRange?.highest_price) || 0;

  const [value, setValue] = useState([lowest, highest]);

  // The price range loads after the first render, so keep the slider in sync
  useEffect(() => {
    setValue([lowest, highest]);
  }, [lowest, highest]);

  const [category, setCategory] = useState([]);

  // While dragging, only the local slider value changes
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // When the user lets go, send the final range to the parent
  // (avoids reloading the products on every pixel of the drag)
  const handleChangeCommitted = (event, newValue) => {
    setPrice?.(newValue);
  };

  const allCategories = useSelector((state) => state.master.categories);
  const allGender = useSelector((state) => state.master.all_gender);
  const allMaterial = useSelector((state) => state.master.all_material);
  const allFrameType = useSelector((state) => state.master.all_frame_type);
  const allColor = useSelector((state) => state.master.all_color);
  const allBrands = useSelector((state) => state.master.brands);
  const allShape = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllGender());

    dispatch(getAllFrameType());

    dispatch(getAllShape());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllMaterial({ category_id: category }));
    dispatch(Brandings({ category_id: category }));
    dispatch(getAllColor({ category_id: category }));
  }, [dispatch, category]);

  // true if the item with this id is selected in filters[key]
  const isChecked = (key, id) =>
    !!(Array.isArray(filters?.[key]) && filters[key].some((item) => item.id === id));

  // Same checkbox list for gender / material / frame type / colour / brands / shape
  const renderOptions = (key, list) =>
    (list || []).map((data) => (
      <div className="fildiv" key={data?.id}>
        <div className="icnnamdiv">
          <p className="icnname">
            <img
              className="icon"
              src={process.env.PUBLIC_URL + FILTER_ICON}
              alt="icon"
            />{" "}
            <span>{data?.name}</span>
          </p>
        </div>
        <div>
          <Form.Check
            type="checkbox"
            checked={isChecked(key, data?.id)}
            onChange={() =>
              onFilterChange(key, {
                id: data?.id,
                name: data?.name,
              })
            }
          />
        </div>
      </div>
    ));

  return (
    <>
      <section className="Product_filter" ref={containerRef}>
        <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
          <Accordion.Item eventKey="0" onClick={handleAccordionOpen}>
            <Accordion.Header>Product Categories</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {allCategories?.map((data) => (
                  <div className="fildiv" key={data?.id}>
                    <div className="icnnamdiv">
                      <p className="icnname">
                        <img
                          className="icon"
                          src={process.env.PUBLIC_URL + FILTER_ICON}
                          alt="icon"
                        />{" "}
                        <span>{data?.name}</span>
                      </p>
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        checked={isChecked("category", data?.id)}
                        onChange={() =>
                          onFilterChange("category", {
                            id: data?.id,
                            name: data?.name,
                          })
                        }
                        onClick={() =>
                          setCategory((prev) => {
                            const prevArr = Array.isArray(prev) ? prev : [];

                            // if already exists -> remove
                            if (prevArr.includes(data.id)) {
                              return prevArr.filter((c) => c !== data.id);
                            }

                            // else add (no duplicates)
                            return [...prevArr, data.id];
                          })
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1" onClick={handleAccordionOpen}>
            <Accordion.Header>Gender</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">{renderOptions("gender", allGender)}</div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2" onClick={handleAccordionOpen}>
            <Accordion.Header>Material</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {renderOptions("material", allMaterial)}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3" onClick={handleAccordionOpen}>
            <Accordion.Header>Frame Type</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {renderOptions("frameType", allFrameType)}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4" onClick={handleAccordionOpen}>
            <Accordion.Header>Colour</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">{renderOptions("colour", allColor)}</div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5" onClick={handleAccordionOpen}>
            <Accordion.Header>Brands</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">{renderOptions("brands", allBrands)}</div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6" onClick={handleAccordionOpen}>
            <Accordion.Header>Frame Shape</Accordion.Header>
            <Accordion.Body>
              <div className="accdata">
                {renderOptions("frameShape", allShape)}
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7" onClick={handleAccordionOpen}>
            <Accordion.Header>Price Range</Accordion.Header>
            <Accordion.Body>
              <div className="accdata range_bar_holder">
                <Slider
                  getAriaLabel={() => "Price range"}
                  value={value}
                  onChange={handleChange}
                  onChangeCommitted={handleChangeCommitted}
                  valueLabelDisplay="auto"
                  min={lowest}
                  max={highest}
                />
                <div className="price_labels">
                  <span>₹{value[0]}</span>
                  <span>₹{value[1]}</span>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </section>
    </>
  );
};

export default Product_filter;